import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "/api",
  withCredentials: true,
});

// Intercepteur de requête : Ajouter le token JWT
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur de réponse : Gérer l'expiration du token (401)
api.interceptors.response.use(
  (response) => {
    window.dispatchEvent(new Event("backend-up"));
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("⚠️ Token expiré ou invalide. Déconnexion automatique.");
      localStorage.removeItem("token");
      localStorage.removeItem("userEmail");
      window.location.href = "/login";
    } else if (
      error.message === "Network Error" ||
      error.code === "ERR_NETWORK" ||
      error.code === "ECONNABORTED"
    ) {
      window.dispatchEvent(new Event("backend-down"));
    }
    return Promise.reject(error);
  }
);

export default api;
